<template>
  <div class="result-card" @click="goToCandidateResults()">
    <ProgressCircle :isNone="compatibility === undefined || compatibility === null" :size="36" :stroke="5" :gapAngle="90" :percentage="compatibility * 100" />
    <div class="candidate-infos">
      <p class="bold">
        {{ participant?.candidate?.first_name || participant?.pending_first_name }}
        {{ participant?.candidate?.last_name || participant?.pending_last_name }}
      </p>
      <p v-text="campaign.campaign.internal_name" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { participationsApi } from '@/api/participations.api';
import { Campaign } from '@/types/campaign';
import { Participant } from '@/types/participant';

const appStore = useAppStore();
const router = useRouter();

const props = defineProps<{
  participant: Participant,
  campaign: Campaign,
}>();

let compatibility = ref<number>(undefined);

async function goToCandidateResults() {
  await router.push({
    name: "campaign",
    params: {
      spaceId: props.campaign.campaign.parent_workspace_id,
      campaignId: props.campaign.id,
    },
    query: {
      tab: 'Results',
    }
  });
  appStore.openedCandidateResults = [props.participant];
  appStore.talentResultPanelIsOpen = true;
}

async function setCompatibilityScore() {
  if (!props.participant) return 0;
  try {
    const res = await participationsApi.getParticipationsCompatibility(props.participant, props.campaign);
    compatibility.value = res;
  } catch (e) {
    compatibility.value = undefined;
  }
}

watch(() => props.participant, async () => {
  await setCompatibilityScore();
});

onMounted(async () => {
  await setCompatibilityScore();
});

</script>